const loadZohoForm = (formUrl, height, width) => {
    try {
        var f = document.createElement("iframe");
        f.src = formUrl;
        f.style.border = "none";
        f.style.height = height || "2600px";
        f.style.width = width || "100%";
        f.style.backgroundColor = "transparent";
        f.style.transition = "all 0.5s ease";
        f.setAttribute("aria-label", 'Form');
        f.allow="camera";

        var d = document.getElementById("form-container");
        d.appendChild(f);

        window.addEventListener('message', function (event) {
            var evntData = event.data;
            if (evntData && evntData.constructor == String) {
                var zf_ifrm_data = evntData.split("|");
                if (zf_ifrm_data.length == 2 || zf_ifrm_data.length == 3) {
                    var zf_perma = zf_ifrm_data[0];
                    var zf_ifrm_ht_nw = (parseInt(zf_ifrm_data[1], 10) + 15) + "px";
                    var iframe = document.getElementById("form-container").getElementsByTagName("iframe")[0];
                    if ((iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(zf_perma) > 0) {
                        var prevIframeHeight = iframe.style.height;
                        var zf_tout = false;
                        if (zf_ifrm_data.length == 3) {
                            iframe.scrollIntoView();
                            zf_tout = true;
                        }
                        if (prevIframeHeight != zf_ifrm_ht_nw) {
                            if (zf_tout) {
                                setTimeout(function () {
                                    iframe.style.height = zf_ifrm_ht_nw;
                                }, 500);
                            } else {
                                iframe.style.height = zf_ifrm_ht_nw;
                            }
                        }
                    }
                }
            }
        }, false);
    } catch (e) {}
}

export default loadZohoForm;
